
import React, { useState, useEffect } from 'react';
import { Category, Account } from '@/types';
import { CategoryItem } from './CategoryItem';
import { toast } from 'sonner';
import { moveCategory } from '@/utils/categoryMovement';

interface CategoryTreeProps {
  categories: Category[];
  accounts: Account[];
  onDrop: (accountId: string, categoryId: string) => void;
  onToggle: (categoryId: string) => void;
  expanded: Set<string>;
  onEdit: (category: Category) => void;
  onReorder?: (categories: Category[]) => void;
  onRemoveAccount?: (accountId: string) => void;
  onDeleteCategory?: (categoryId: string) => void;
  onSelect?: (category: Category) => void;
  selectedCategory?: Category | null;
}

export const CategoryTree: React.FC<CategoryTreeProps> = ({
  categories,
  accounts,
  onDrop,
  onToggle,
  expanded,
  onEdit,
  onReorder,
  onRemoveAccount,
  onDeleteCategory,
  onSelect,
  selectedCategory
}) => {
  console.log('CategoryTree rendering with categories:', categories, 'selectedCategory:', selectedCategory?.id);
  
  // Force update when selectedCategory changes
  const [, forceUpdate] = useState({});
  
  useEffect(() => {
    // Force a re-render when selectedCategory changes
    forceUpdate({});
  }, [selectedCategory]);

  const handleMoveUp = (categoryId: string, parentId: string | null) => {
    if (onReorder) {
      const newCategories = moveCategory(categories, categoryId, parentId, 'up');
      onReorder(newCategories);
      toast.success('Category moved successfully');
    }
  };

  const handleMoveDown = (categoryId: string, parentId: string | null) => {
    if (onReorder) {
      const newCategories = moveCategory(categories, categoryId, parentId, 'down');
      onReorder(newCategories);
      toast.success('Category moved successfully');
    }
  };

  return (
    <div className="mt-4 space-y-1 rounded-lg p-4 overflow-y-auto max-h-[800px] pr-2">
      {categories.map((category, index) => (
        <CategoryItem
          key={category.id}
          category={category}
          accounts={accounts}
          onDrop={onDrop}
          onToggle={onToggle}
          expanded={expanded}
          level={0}
          index={index}
          onEdit={onEdit}
          totalItems={categories.length}
          onRemoveAccount={onRemoveAccount}
          onMoveUp={handleMoveUp}
          onMoveDown={handleMoveDown}
          onDeleteCategory={onDeleteCategory}
          isFirst={index === 0}
          isLast={index === categories.length - 1}
          onSelect={onSelect}
          isSelected={selectedCategory?.id === category.id}
          selectedCategory={selectedCategory}
        />
      ))}
    </div>
  );
};
